// Angular
import { Injectable } from "@angular/core";
// External
import { AngularFireDatabase } from "angularfire2/database";
import { Subscription } from "rxjs/Subscription";
import * as lodash from "lodash";

@Injectable()
export class ElasticService {
  private key: string;
  private subscription: Subscription;

  constructor(private fireDatabase: AngularFireDatabase) {}

  public search(queryParams: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.key = this.fireDatabase.database.ref("/search/request/").push().key;
      this.fireDatabase
        .object(`/search/request/${this.key}`)
        .update(queryParams);
      this.subscription = this.fireDatabase
        .list(`/search/response/${this.key}`)
        .subscribe(
          result => {
            const hitsIndex = lodash.findIndex(result, "hits");
            if (hitsIndex !== -1) {
              resolve(result[hitsIndex]);
              this.subscription.unsubscribe();
              this.fireDatabase.object(`/search/response/${this.key}`).remove();
            }
          },
          error => {
            reject(error);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/app/services/elastic/elastic.service.ts